export default "__VITE_ASSET__DHjLmBwA__"